import React from 'react'
import styled from 'styled-components'
import { Flex, H4, Image } from 'ui/bend'

import { ResponsiveSVG } from 'ui/acro'
import { useUserContext } from 'context'
import vipSVG from '../../../../assets/images/vipAccessLevel.svg'
import allAccessSVG from '../../../../assets/images/allAccessLevel.svg'
import aListSVG from '../../../../assets/images/aListAccessLevel.svg'

const Container = styled(Flex)({
  gap: '4px',
  '@media (min-width: 640px)': {
    gap: '12px'
  }
})

const TextSection = styled(Flex)({
  gap: '6px',
  flexDirection: 'column',
  '@media (min-width: 640px)': {
    gap: '8px'
  }
})

const NameHeader = styled(H4)({
  letterSpacing: '-0.72px',
  fontWeight: '400'
})

const VerticalDivider = styled('span')({
  fontWeight: 600,
  lineHeight: '16px',
  letterSpacing: '0.7px'
})

const BottomSection = styled(Flex)({
  gap: '4px',
  alignItems: 'center'
})

const PointsSection = styled(Flex)({
  fontFamily: 'proxima-nova',
  fontSize: '14px',
  fontWeight: 400,
  linHeight: '18px',
  letterspacing: '0.308px'
})

const kettleBellIcon = {
  tier1: 'https://d28gwrkukqy4h7.cloudfront.net/alo_access_tiers/vip.png',
  tier2: 'https://d28gwrkukqy4h7.cloudfront.net/alo_access_tiers/a_list.png',
  tier3: 'https://d28gwrkukqy4h7.cloudfront.net/alo_access_tiers/all_access.png'
}

const getUserLevelImage = (userAloTier) => {
  const tier = String(userAloTier).at(-1)
  switch (Number(tier)) {
    case 1:
      return <ResponsiveSVG SVG={vipSVG} width='20px' height='16px' />
    case 2:
      return <ResponsiveSVG SVG={aListSVG} width='29px' height='18px' />
    case 3:
      return <ResponsiveSVG SVG={allAccessSVG} width='65px' height='19px' />
    default:
      return null
  }
}

export const AloAccessUserLevelAndPoints = () => {
  const { user } = useUserContext()
  const userAloTier = user?.userAloTier
  const userAloPoints = user?.userAloPoints

  return (
    <Container>
      {kettleBellIcon[userAloTier] && (
        <Image
          src={kettleBellIcon[userAloTier]}
          alt={'kettle bell image'}
          width={['41px', '50px']}
          height={['46px', '55px']}
        />
      )}

      <TextSection>
        <NameHeader>Hello, {user?.firstName}</NameHeader>
        <BottomSection>
          {getUserLevelImage(userAloTier)}
          <VerticalDivider>|</VerticalDivider>
          {Number(userAloPoints) > 0 && (
            <PointsSection>{userAloPoints} PTS</PointsSection>
          )}
        </BottomSection>
      </TextSection>
    </Container>
  )
}
